export default {
  getPerPage: (tab) => {
    return 15
  },
  getHead: () => {
    return [
      {name: 'No.', style:{minWidth:'100px', width:'100px'}},
      {name: '사업장명', key: 'field_name'},
      {name: '사업장관리번호', key: 'contract_code'},
      {name: '대표자', key: 'director_name'},
      {name: '업종', key: 'meta_industry'},
      {name: '소재지', key: 'address'},
    ]
  } ,
  getCol: (index, row, func) => {
    try {
      switch (index) {
        // No.
        case 0: return func.no

        // 사업장명
        case 1: return row.field_name || "-"

        // 사업장관리번호
        case 2: return row.contract_code || "-"

        // 대표자
        case 3: return row.director_name || "-"

        // 업종
        case 4: {
          if (row.meta) {
            let meta = row.meta
            meta = JSON.parse(meta)
            return meta["업종"] || "-"
          }
          return "-"
        }

        // 소재지
        case 5: return row.address || "-"

      }
    } catch (e) { /*ignore*/ }
    return ''
  },
}
